import type { ParsedToken, User as FirebaseUser } from 'firebase/auth';
import type { UserContextType } from './UserContext';

type UserAction =
  | {
      type: 'login';
      user: FirebaseUser;
    }
  | {
      type: 'load-data';
      userData: introwise.User;
    }
  | {
      type: 'logout';
    }
  | {
      type: 'load-claims';
      claims: ParsedToken;
    };

const userReducer = (state: UserContextType, action: UserAction): UserContextType => {
  switch (action.type) {
    case 'login':
      if (action.user === state.user) {
        return state.loggingIn ? { ...state, loggingIn: false } : state;
      }
      return {
        ...state,
        loggingIn: false,
        loading: true,
        user: action.user,
        claims: undefined,
        claimsLoading: true,
      };
    case 'load-data':
      return {
        ...state,
        loading: false,
        userData: action.userData,
      };
    case 'load-claims':
      return {
        ...state,
        claims: action.claims,
        claimsLoading: false,
      };
    case 'logout':
      return {
        user: undefined,
        loggingIn: false,
        loading: false,
        userData: undefined,
        claims: undefined,
        claimsLoading: false,
      };
  }
};

export { userReducer };
export type { UserAction };
